import { Asset, AssetEntitlement, UserProgram } from 'app/types/asset.types'

// will return a multidimensional array of *classes* and *assets* assigned to classes
export const collectAssetsFromEntitlements = (
  entitlements: AssetEntitlement[]
): Asset[][] =>
  entitlements.map((entitlement) =>
    entitlement.programs.map((program) => program.assets).flat()
  )

export const collectAssetsFromUserPrograms = (
  programs: UserProgram[]
): Asset[][] =>
  programs.map((program) =>
    program.contents.map((content) => content.assets).flat()
  )
